import { ReactNode } from 'react';

import { Flex, Text } from '@raystack/apsara';

import { SquareThumbnail } from '@src/components/Custom/Thumbnails';

export interface InferenceAssetItem {
  src: string;
  name: string;
  children: ReactNode;
}

export const InferenceAssetItem = ({
  src,
  name,
  children
}: InferenceAssetItem) => {
  return (
    <Flex gap='small'>
      <SquareThumbnail src={src} />
      <Flex direction='column' gap='extra-small' justify='center' align='start'>
        <Text size={4} weight={500}>
          {name}
        </Text>
        {children}
      </Flex>
    </Flex>
  );
};
